var lx = lx || {};

/* Initialy created by Senthil
* 20.02.2020 by Davor: Transfered from oldIR to IR
*   added an irView status variable for tracking ir state, so when resizing multiple requests are not sent before the initial one is done (and changes is-active class)
*   added support for multiple ir-s like we will have on project setup pages
* Examples
* single   lx.apexir.views('staticId1');
* multiple lx.apexir.views(['staticId1','staticId2']);
*/
lx.apexir = {
    irView: {},
    views:  function(pId) {
        var ids = (Array.isArray(pId) ? pId : [pId]);
        for (var i = 0; i < ids.length; i++) {
            var id = ids[i];
            // Init status
            if (!lx.apexir.irView[id]) lx.apexir.irView[id] = ($("#" + id + "_report_view").hasClass("is-active") ? 'report' : 'detail');
    
            if (lx.apexir.irView[id] == 'report' && $(window).width() < 960/* && $("#" + id + "_report_view").hasClass("is-active")*/) {
                $("#" + id + " button.a-IRR-button--views[data-view=details]").click();
                lx.apexir.irView[id] = 'detail';
            } else if (lx.apexir.irView[id] == 'detail' && $(window).width() > 961/* && $("#" + id + "_detail_view").hasClass("is-active")*/) {
                $("#" + id + " button.a-IRR-button--views[data-view=report]").click();
                lx.apexir.irView[id] = 'report';
            }
        }
    },
	hideCols: function (pCols) {
		// All columns must have same static ID as columns mentioned in parameter
		var a = pCols.split(':');
		var l = a.length;
		for (var i = 0; i < l; i++) {
			$("#"+a[i]).addClass("hidden-sm-down");
			$("td").each(function(){
				var h = $(this).attr("headers");
				if (h == a[i]) {
					$(this).addClass("hidden-sm-down");
				}
			});
		}
		// Remove fixed width to filter label
		$(".a-IRR-controls-cell--label").css("width", "unset");
		$(".a-IRR-controls-cell--label").css("max-width", "300px");
	},
	addToCollection: function (pType,pThis,pCallback) {
		var str = '';
		var val = 'Y';
		if (pThis.value!=='' && pThis.value!==undefined) {
			//alert(1);
			str = pThis.value;
			if (pThis.checked) {
				val = 'Y';
			} else {
				val = 'N';
			}
		}
		else {
			//alert(2);
			$("input[name='f01']").each( function (i){
				$(this).prop('checked', true);
				str = str + ":" + this.value;
			});
		}
	    //alert(str+"--"+val);
		apex.server.process("addToCollection", {
			x01: str,
			x02: val,
			x03: pType
		}, {
			dataType: "text",
			success: function (d) {	
				/*pCallback(pType);*/
				null;
			}
		});
	},
	countCollection: function (pType) {
		var ret = 0;
		//alert(pType);
		apex.server.process("CHECKBOX_CNT", {
				x01: pType
			}, {
				dataType: "text",
				success: function (d) {
					ret = d;
					if (pType == 'NLR' || pType == 'SUR' || pType == 'CON') lx.info.success("Selected contacts: " + d);
					else lx.info.success("Selected records: " + d);
				}
			});
		return ret;
	},
	clearCollection: function (pType,pCallback) {
		var ret = 0;
		//alert(pType);
		$("input[name='f01']").each( function (i){
			$(this).prop('checked', false);
		});		
		apex.server.process("f_chkbox_list", {
			x01: ''
		}, {
			dataType: 'text',
			success: function (d) {
				null;//alert(d);
			}
		});
		apex.server.process("clearCollection", {
				x01: pType
			}, {
				dataType: "text",
				success: function (d) {	
					if (pType !== 'CON') { 
						pCallback(pType);
					}
					
				}
			});
		return ret;
    },
    getIcons: function (pType) {
        var lIds = [], lIdsSecondary = [], lEtys = [], lIcons = [], lParams = [], lDataCols = [], lDataColPars = [];
        $(".lxProjectIcons").each(function (){ 
          var $this = $(this);
          lIds.push($this.attr("data-id"));
          lIdsSecondary.push($this.attr("data-id-secondary"));
          lEtys.push($this.attr("data-ety"));
          lIcons.push($this.attr("data-icons"));
          lParams.push($this.attr("data-params"));
          //console.log("getIcons data-cols:"+ $this.attr("data-cols"));
          if ($this.attr("data-cols")) {
            lDataCols.push($this.attr("data-cols"));
            lDataColPars.push($nvl($this.attr("data-cols-par"),'0'));
          }
        });
        apex.server.process("lxIrIcons",{f01:lEtys,f02:lIds,f03:lIcons,f04:lParams,f05:lDataCols,f06:lDataColPars,f07:lIdsSecondary}, {dataType: "json"})
            .done(function (d){
                d.rows.forEach( function (obj) {
                    var $col = $(".lxProjectIcons[data-id="+ obj.id +(obj.idSecondary ? '][data-id-secondary='+obj.idSecondary : '') +"]");
                    var $row = $col.closest(".irRow, .lxpCard");
                    if (pType == 'CARDS') {
                        $col.replaceWith($(obj.html).html());
                        $('.lazy-Btn-Ir').removeClass('lazy-Btn-Ir');
                    } else {
                        $col.replaceWith(obj.html);
                        if (obj.cols){
                            
                        //  console.log( $row.html() );
                            obj.cols.forEach( function (col) {
                                //console.log(".lxIrCol-"+ col.id + ">p : "+ col.html);
                                if (col.id == 'IMAGE' || col.id == 'IMAGE2' || col.id == 'IMAGEW') $row.find(".lxIrCol-"+ col.id).html(col.html);
                                else if (col.id == 'AMOUNT_OWED') $row.find(".lxIrCol-PAYMENT_TYPE > .amount_owed").html(col.html);
                                else $row.find(".lxIrCol-"+ col.id + ">p").html(col.html);
                            });
                        };
                    }
                });
            });
    },
	bulkDialog: function (pEty,pDocType,pAction,pCheck) {		
		var lButtons = [];
		var vCkd = [];
		var lBtnLabel='';
		var lBtnIcon='';
		var lDialogTitle='';
		var lMessage='';
		if (pAction=='DELETE') {
			lBtnLabel=apex.lang.formatMessage(pAction);
			lBtnIcon='far fawe-trash-alt';
			//lDialogTitle=apex.lang.formatMessage('DOCUMENT_DELETE');
			if (pEty !== 'CONTACTS') {
			  lMessage='SUCCESSFULLY_DELETED';
			} 
			else { 
			  lMessage='SUCCESSFULLY_DELETED_CON';
			}
		}
		else if (pAction=='ARCHIVE') {
			lBtnLabel=apex.lang.formatMessage(pAction);
			lBtnIcon='far fawe-archive';
			//lDialogTitle=apex.lang.formatMessage('DOCUMENT_ARCHIVE');
			if (pEty !== 'CONTACTS') {
			  lMessage='SUCCESSFULLY_ARCHIVED';
			} 
			else { 
			  lMessage='SUCCESSFULLY_ARCHIVED_CON';
			}
		}
		else if (pAction=='ARCHIVE_DISC') {
			lBtnLabel=apex.lang.formatMessage(pAction);
			lBtnIcon='far fawe-archive';
			//lDialogTitle=apex.lang.formatMessage('DOCUMENT_ARCHIVE');
			 lMessage='SUCCESSFULLY_ARCHIVED';
		}
		else if (pAction=='DISCONNECT') {
			lBtnLabel=apex.lang.formatMessage(pAction);
			lBtnIcon='far fawe-archive';
			//lDialogTitle=apex.lang.formatMessage('DOCUMENT_ARCHIVE');
			 lMessage='SUCCESSFULLY_DISCONNECTED';
		}
		else if (pAction=='SETTLE') {
			lBtnLabel=apex.lang.formatMessage(pAction);
			lBtnIcon='far fawe-archive';
			//lDialogTitle=apex.lang.formatMessage('DOCUMENT_SETTLE');
			lMessage='SUCCESSFULLY_SETTLED';
		}
		else if (pAction=='EXPORT') {
			lBtnLabel=apex.lang.formatMessage(pAction);
			lBtnIcon='far fawe-file-export';
			//lDialogTitle=apex.lang.formatMessage('DOCUMENT_EXPORT');
			lMessage='SUCCESSFULLY_EXPORTED';
		}
		$('input[name="f01"]:checked').each(function() {
		   vCkd.push(this.value);
		});
		//console.log(vCkd.toString());
		apex.server.process("bulkAction", {
			x01: pDocType,
			x02: pAction,
			x03: vCkd.toString(),
			x04: pCheck,
			x05: pEty
			}, {
				dataType: "html",
				success: function (ret) {
					if (pCheck=='Y') {
						var val=ret.split('~');
						console.log(val[0]+"~"+val[1]+"~"+val[2]);
						if (val[1]=='NO_DOCUMENTS_SELECTED' || val[1]=='NO_CONTACTS_SELECTED') {
							//lx.info.error(apex.lang.formatMessage(val[1]));					
							var dialogDiv = '<div class="t-Alert t-Alert--horizontal t-Alert--defaultIcons t-Alert--info t-Alert" style="margin-bottom:0rem;"><div class="t-Alert-wrap" style="display: block;text-align: center;"><div class="t-Alert-icon" style="padding: 3.2rem 3.2rem 1.6rem 3.2rem;"><span class="t-Icon" style="font-size: 4.8rem;width: 4.8rem;height: 4.8rem;"></span></div><div style="width:100%;padding:1.6rem 3.2rem 3.2rem 3.2rem;">' + apex.lang.formatMessage(val[1]) + '</div></div></div>';
							lButtons.push({label: lx.tran.get("CLOSE"), id: "id"+pDocType+pAction, js: "$('.lxpDialog').css('display','none');", fa:'far fawe-times'});
							lx.dialog.open({id:'BULKACTION'/*pDocType+pAction*/, maxWidth: "690px", html: dialogDiv, title: lDialogTitle,  buttons: lButtons});
						}
						else if (val[1]=='NO_OF_NON_PROCESSED_DOCUMENTS' || val[1]=='NO_OF_NON_PROCESSED_CONTACTS' || val[1]=='NO_OF_NON_PROCESSED_CONTACT') {
							/*lx.info.error(apex.lang.formatMessage(val[1],val[0])+val[2]);	*/						
							var dialogDiv = '<div class="t-Alert t-Alert--horizontal t-Alert--defaultIcons t-Alert--warning t-Alert" style="border: 1px solid #FEF7E0;background-color: #FEF7E0;margin-bottom:0rem;"><div class="t-Alert-wrap" style="display: block;text-align: center;"><div class="t-Alert-icon" style="padding: 3.2rem 3.2rem 1.6rem 3.2rem;"><span class="t-Icon" style="color: #FFC628;font-size: 4.8rem;width: 4.8rem;height: 4.8rem;"></span></div><div style="width:100%;padding:1.6rem 3.2rem 3.2rem 3.2rem;">' + apex.lang.formatMessage(val[1],val[0])+val[2] + '</div></div></div>';
							if ((val[1]=='NO_OF_NON_PROCESSED_CONTACTS' || val[1]=='NO_OF_NON_PROCESSED_CONTACT') && val[0] !== '0') {
							  lButtons.push({label: lx.tran.get('YES'), id: "id"+pDocType+pAction, js: "lx.apexir.bulkDialog('"+pEty+"','"+pDocType+"','"+pAction+"','N');", class: "t-Button--primary", fa:'far fawe-check'});
							}
							lButtons.push({label: lx.tran.get("CANCEL_BTN"), id: "id"+pDocType+pAction, js: "$('.lxpDialog').css('display','none');", fa:'far fawe-times'});
							lx.dialog.open({id:'BULKACTION'/*pDocType+pAction*/, maxWidth: "690px", html: dialogDiv, title: lDialogTitle,  buttons: lButtons});
						}
						else {							
							var dialogDiv = '<div class="t-Alert t-Alert--horizontal t-Alert--defaultIcons t-Alert--warning t-Alert" style="border: 1px solid #FEF7E0;background-color: #FEF7E0;margin-bottom:0rem;"><div class="t-Alert-wrap" style="display: block;text-align: center;"><div class="t-Alert-icon" style="padding: 3.2rem 3.2rem 1.6rem 3.2rem;"><span class="t-Icon" style="color: #FFC628;font-size: 4.8rem;width: 4.8rem;height: 4.8rem;"></span></div><div style="width:100%;padding:1.6rem 3.2rem 3.2rem 3.2rem;">' + apex.lang.formatMessage(val[1],val[0])+val[2] + '</div></div></div>';
							lButtons.push({label: lx.tran.get("YES"), id: "id"+pDocType+pAction, js: "lx.apexir.bulkDialog('"+pEty+"','"+pDocType+"','"+pAction+"','N');", class: "t-Button--primary", fa:'far fawe-check'},{label: lx.tran.get("CANCEL_BTN"), id: "id"+pDocType+pAction, js: "$('.lxpDialog').css('display','none');", fa:'far fawe-times'});
							lx.dialog.open({id:'BULKACTION'/*pDocType+pAction*/, maxWidth: "690px", html: dialogDiv, title: lDialogTitle, buttons: lButtons});
							
						}
					}
					else {
						if (pAction=='EXPORT') {
							var returnStr = ret.substr(0, ret.indexOf('~'));
							var gReturn = ret.replace(returnStr + '~', '');
                            apex.navigation.redirect(gReturn);
						}
						else {
							apex.event.trigger( "#"+lx.apexir.getId(), "apexrefresh" );
							//lx.info.success(apex.lang.formatMessage(lMessage,ret.replace(/&para;/g, '')));
							$('.lxpDialog').css('display','none');
						}
					}
				}
			});
	},
	getId: function () {
		var lPgId = $v("pFlowStepId");
		if (lPgId==308) {return "IR-COMMERCIAL";}
		else if (lPgId==243) {return "IR-WAREHOUSE";}
		else if (lPgId==5) {return "IR-HR_FORM";}
		else if (lPgId==21) {return "IR-NEWS";}
		else if (lPgId==23) {return "IR-EVENTS";}
		else if (lPgId==22) {return "IR-JOBS";}
		else if (lPgId==25) {return "IR-BID";}
		else if (lPgId==105) {return "IR-CONTACT";}
		else if (lPgId==303) {return "certIR";}
		else if (lPgId==931) {return "IR-SURVEY";}
		else if (lPgId==309) {return "IR-NEWSLETTER";}
		else if (lPgId==1007) {return "IR-ROADMAP";}
		else {return '';}
	}
}
/* Created by Davor on 11.07.2019
 JSON based IR

 eg. lx.ir.init({irCode:'CONTACT',page:1,params:[0, "A", 0, 0, 'N']});
*/
lx.ir = {
    data: { genData: {}, row: {} },
    html: '',
    header: '',
    records: '',
    pagination: '',
    init: function (pOptions) {
        this.data.genData.irCode = pOptions.irCode;
        this.data.genData.page = pOptions.page;
        this.data.genData.searchTerm = '';
        this.data.genData.searchCol = 1;
        this.data.genData.dateFrom = '';
        this.data.genData.dateTo = '';
        this.data.genData.params = pOptions.params;

        this.getData('INIT');
    },
    initHtml: function (pData) {
        this.data = pData;
        this.render("HTML", this);
    },
    getData: function (pRetType) {
        var self = this;
        lx.load.add();
        apex.server.process("lxpIR", {
            x01: self.data.genData.irCode,
            x02: pRetType,
            x03: self.data.genData.page,
            x04: self.data.genData.searchTerm,
            x05: self.data.genData.searchCol,
            x06: self.data.genData.dateFrom,
            x07: self.data.genData.dateTo,
            f01: self.data.genData.params
        }, {
            dataType: "json",
            success: function (d) {
                lx.load.remove();
                if (pRetType == 'FILTER') {
                    self.data.row = d.row;
                    self.data.totalCnt = d.totalCnt;
                    if (d.params) self.data.genData.params = d.params;
                } else if (pRetType == 'PAGE') {
                    self.data.row = d.row;
                    if (d.params) self.data.genData.params = d.params;
                } else self.data = d;

                self.render(pRetType, self);
            }
        });
    },
    render: function (pRetType, self) {
        self.renderRecords(self);
        self.renderPagination(self);
        if (pRetType == 'INIT' || pRetType == 'HTML') {
            self.renderHeader(self);
            /*var lBtns = '';
            if (self.data.region.btns) {
                for (var x = 0; x < self.data.region.btns.length; x++) {
                    lBtns += lx.btn.gen(self.data.region.btns[x]);
                }
            }
            self.html = '<section id="IR-region-' + self.data.genData.irCode + '" class="clearfix ' + self.data.region.class + '">' + 
                '<div class="uRegionHeading_lp"><h2>' + self.data.region.title + '</h2>' +
                '<span class="uButtonContainer">' + lBtns + '</span>' + 
                '</div><div class="uRegionContent clearfix">' + 
                '<div class="a-IRR a-IRR-custom a-IRR-resp" id="IR-' + self.data.genData.irCode + '">' + self.header + self.records + self.pagination + '</div>' + 
                '</div></section>';*/
            self.html = self.header + self.records + self.pagination;
            self.html = lx.region.gen({ id:'IR-region-' + self.data.genData.irCode, 
                                        title: self.data.region.title,
                                        btns: self.data.region.btns,
                                        content: self.html,
                                        contentClass: 'lxIr',
                                        contentId: 'IR-' + self.data.genData.irCode
                                    });
            //console.log(self.html);
            $("#IR-" + self.data.genData.irCode).replaceWith(self.html);
            // init datepickers
            if (self.data.genData.dateFilter) {
                $("#IR-" + self.data.genData.irCode + " .lxIrSearchContainer input.lxIrDateField[type=text]")
                    .datepicker({ dateFormat: translation.date_format })
                    .change(function () { $(this).closest(".lxIr").find(".lxIrSearchBtn").addClass("red"); });
            }
            if (self.data.filterItems) {
                for (var x = 0; x < self.data.filterItems.length; x++) {
                    var filter = self.data.filterItems[x];
                    $('#' + filter.id).change(function () { $(this).closest(".lxIr").find(".lxIrSearchBtn").addClass("red"); });
                }
            }
        } else {
            $("#IR-" + self.data.genData.irCode + " .records").replaceWith(self.records);
            $("#IR-" + self.data.genData.irCode + " .pagination").replaceWith(self.pagination);
        }
    },
    renderHeader: function (self) {
        self.header = '<div class="row">';
        if (self.data.filterItems) {
            for (var x = 0; x < self.data.filterItems.length; x++) {
                var item = self.data.filterItems[x];
                self.header += lx.item.gen({ "id": item.id, "item": item, "data": self.data.genData.params[item.paramNo - 1] });
            }
        }
        self.header += '</div>';
        self.header += '<div class="lxIrSearchContainer row"><div class="col-xs-12 col-sm-12 col-md-12 ' + (self.data.genData.dateFilter ? 'col-lg-6' : 'col-lg-12') + '">' + 
            '<div class="lxIrSelectCol"><span onclick="$(this).closest(\'.lxIrSelectCol\').find(\'ul\').toggle();"></span><ul>';
        var lPlaceholder;
        var lFilterJs = 'lx.ir.filter(this);';
        // Search columns
        for (var sc = 0; sc < self.data.searchCols.length; sc++) {
            self.header += '<li onclick="lx.ir.setSearchCol(this, ' + (sc + 1) + ');">' + self.data.searchCols[sc] + '</li>';
            if (self.data.genData.searchCol == (sc + 1)) lPlaceholder = self.data.searchCols[sc];
        }
        self.header += '</ul></div><input class="lxIrSearch" placeholder="' + lPlaceholder + '" type="text" value="' + 
            (self.data.genData.searchTerm ? self.data.genData.searchTerm : "") + 
            '" onkeydown="if(event.keyCode == 13) {' + lFilterJs + 
            '}" tabindex="1" /><div onclick="' + lFilterJs + '" class="lxIrSearchBtn">Go</div></div>';
        // Date filter
        if (self.data.genData.dateFilter) {
            self.header += '<div class="col-xs-12 col-sm-4 col-md-4 col-lg-3" style="color:#888;text-align:center;">' + self.data.genData.dateLabel + '</div>' + 
                '<div class="col-xs-12 col-sm-8 col-md-8 col-lg-3">' + 
                '<input class="lxIrDateField lxIrDateFrom" type="text" placeholder="Start of time" value="' + (self.data.genData.dateFrom ? self.data.genData.dateFrom : "") + '" />' + 
                '<div class="lxIrDateFieldSep">-</div>' + 
                '<input class="lxIrDateField lxIrDateTo" type="text" value="' + (self.data.genData.dateTo ? self.data.genData.dateTo : "") + '" />' +
                //'<div onclick="' + lFilterJs + '" class="lxIrSearchBtn">Go</div>' +
                '</div>';
        }
        self.header += '</div>';
        /*
        self.header = '';
        if (self.data.filterItems) {
            self.header += '<div class="lxpForm lxIrFilters row">';
            for (var x = 0; x < self.data.filterItems.length; x++) {
                var item = self.data.filterItems[x];
                self.header += lx.item.gen({ "id": item.id, "item": item, "data": self.data.genData.params[item.paramNo - 1] });
            }
            self.header += '</div>';
        }
        self.header += '<div class="lxIrSearchContainer row"><div class="col-xs-12 col-sm-12 col-md-12 ' + (self.data.genData.dateFilter ? 'col-lg-6' : 'col-lg-12') + '">' + 
            '<div class="lxIrSelectCol"><span onclick="$(this).closest(\'.lxIrSelectCol\').find(\'ul\').toggle();"></span><ul>';
        var lPlaceholder;
        var lFilterJs = 'lx.ir.filter(this);';
        // Search columns
        for (var sc = 0; sc < self.data.searchCols.length; sc++) {
            self.header += '<li onclick="lx.ir.setSearchCol(this, ' + (sc + 1) + ');">' + self.data.searchCols[sc] + '</li>';
            if (self.data.genData.searchCol == (sc + 1)) lPlaceholder = self.data.searchCols[sc];
        }
        self.header += '</ul></div><input class="lxIrSearch" placeholder="' + lPlaceholder + '" type="text" value="' + 
            (self.data.genData.searchTerm ? self.data.genData.searchTerm : "") + 
            '" onkeydown="if(event.keyCode == 13) {' + lFilterJs + 
            '}" tabindex="1" /><div onclick="' + lFilterJs + '" class="lxIrSearchBtn">Go</div></div>';
        // Date filter
        if (self.data.genData.dateFilter) {
            self.header += '<div class="col-xs-12 col-sm-4 col-md-4 col-lg-3" style="color:#888;text-align:center;">' + self.data.genData.dateLabel + '</div>' + 
                '<div class="col-xs-12 col-sm-8 col-md-8 col-lg-3">' + 
                '<input class="lxIrDateField lxIrDateFrom" type="text" placeholder="Start of time" value="' + (self.data.genData.dateFrom ? self.data.genData.dateFrom : "") + '" />' + 
                '<div class="lxIrDateFieldSep">-</div>' + 
                '<input class="lxIrDateField lxIrDateTo" type="text" value="' + (self.data.genData.dateTo ? self.data.genData.dateTo : "") + '" />' +
                //'<div onclick="' + lFilterJs + '" class="lxIrSearchBtn">Go</div>' +
                '</div>';
        }
        self.header += '</div>';
        */
    },
    renderRecords: function (self) {
        self.records = '';
        // header
        for (var i = 0; i < self.data.columns.length; i++) {
            var hdr = self.data.columns[i];
            var style = (hdr.width ? 'width:' + hdr.width : '');
            self.records += '<div class="' + (hdr.align ? ' t' + hdr.align : '') + 
                (hdr.classResp ? ' ' + hdr.classResp : '') + 
                '"' + (style ? ' style="' + style + '"' : '') + 
                '>' + (hdr.hdr ? hdr.hdr : '') + '</div>';
        }
        self.records = '<div class="irRow">' + self.records + '</div>';
        // records
        for (var i = 0; i < self.data.row.length; i++) {
            self.records += self.renderRow(self.data.row[i], self.data.columns);
        }
        self.records = '<div class="records lxpFlexTbl">' + self.records + '</div>';
    },
    renderRow: function (row, hdrs) {
        var rowHtml = '';
        for (var i = 0; i < hdrs.length; i++) {
            var hdr = hdrs[i];
            var lClass = '';
            var value = '', style = (hdr.width ? 'width:' + hdr.width + ';' : '') + (hdr.link || hdr.js ? 'cursor:pointer;' : '') + (hdr.style ? hdr.style : '');
            if (hdr.checkbox) {
                value = '<input type="checkbox" onclick="checkboxChg(this, \'' + hdr.collection + '\',\'' + row[hdr.idRef] + 
                    '\');" value="' + row[hdr.idRef] + '" name="f01"' + (row[hdr.id] ? ' checked="checked"' : '') + '>';
            } else if (hdr.img) {
                value = lx.profile.genPic(row[hdr.id]);
                /*if (typeof row[hdr.id] != 'undefined') {
                    if (row[hdr.id][0].type == 'INIT') {
                        var initials = row[hdr.id][0].name.split(/\s/).reduce((response, word) => response += word.slice(0, 1), '');
                        initials = initials.split('');
                        initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
                        value += '<div class="IR-img__big IR-img__init" title="' + row[hdr.id][0].name + '">' + initials + '</div>';
                    } else value = '<img class="IR-img__big" src="LINXPOT.multimedia.thumb?p_id=' + row[hdr.id][0].id + '&p_maxscale=96 96&p_type=' + row[hdr.id][0].type + '" />';

                    if (row[hdr.id].length > 1) {
                        if (row[hdr.id][1].type == 'INIT') {
                            var initials = row[hdr.id][1].name.split(/\s/).reduce((response, word) => response += word.slice(0, 1), '');// function (response, word) { return response += word.slice(0, 1); }
                            initials = initials.split('');
                            initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
                            value += '<div class="IR-img__small IR-img__init" title="' + row[hdr.id][1].name + '">' + initials + '</div>';
                        } else value += '<img class="IR-img__small" src="LINXPOT.multimedia.thumb?p_id=' + row[hdr.id][1].id + 
                                    '&p_maxscale=40 40&p_type=' + row[hdr.id][1].type + 
                                    (row[hdr.id][1].org ? '&p_rec_id=' + row[hdr.id][1].org : '') + '" />';
                    }
                    value = '<div class="IR-img">' + value + '</div>';
                }*/
            } else if (hdr.iconCnt) {
                value = '<i class="' + hdr.fa + '"></i><br /><span>' + row[hdr.id] + '</span>';
            } else if (hdr.icon) {
                if (row[hdr.id]) value = '<i class="' + hdr.fa + '"></i>';
                lClass += 'fa-icon';
            } else {
                value = row[hdr.id];
            }
            lClass += (hdr.class ? ' ' + hdr.class : '') + 
                (hdr.classResp ? ' ' + hdr.classResp : '') + 
                (hdr.classRef && row[hdr.classRef] ? ' ' + row[hdr.classRef] : '') + 
                (hdr.align ? ' t' + hdr.align : '');
            
            rowHtml += '<div' + (lClass ? ' class="' + lClass + '"' : '') + 
                (style ? ' style="' + style + '"' : '') + 
                (hdr.js ? ' onclick="' + hdr.js.replace('#id#', row.id) + '" style="cursor:pointer"' : '') + 
                (hdr.title ? ' title="' + hdr.title + '"' : '') + 
                '>' + 
                (hdr.link ? '<a href="' + row[hdr.link] + '">' : '')+ 
                (value ? value : '') + 
                (hdr.link ? '</a>' : '')+ 
                '</div>';
        }
        return '<div class="irRow"' + (row.id ? ' rowid="' + row.id + '"' : '') + '>' + rowHtml + '</div>';
    },
    renderPagination: function (self) {
        var lPages = Math.ceil(self.data.totalCnt / self.data.genData.pageRows);
        self.pagination = '';
        // First and Previous link
        if (self.data.genData.page != 1)
            self.pagination += '<span onclick="lx.ir.changePage(1);" title="First Page"><<</span>' + 
                '<span onclick="lx.ir.changePage(-1, true);" title="Previous Page"><</span>';
        // Pagination range
        var lBuff = 10, lMin = 1, lMax = lPages;
        if (self.data.genData.page > lBuff && self.data.genData.page < (lPages - lBuff)) {
            lMin = self.data.genData.page - lBuff;
            lMax = self.data.genData.page + lBuff;
        } else if (self.data.genData.page <= lBuff && lPages > (2 * lBuff)) {
            lMax = 2 * lBuff;
        } else if (self.data.genData.page >= (lPages - lBuff) && lPages > (2 * lBuff)) {
            lMin = lPages - (2 * lBuff);
        }
        for (var x = lMin; x <= lMax; x++) {
            if (x == self.data.genData.page) self.pagination += '<span class="lxIrCurrentPg">' + x + '</span>';
            else self.pagination += '<span onclick="lx.ir.changePage(' + x + ');">' + x + '</span>';
        }
        // Last and previous link
        if (self.data.genData.page != lPages && lPages > 1)
            self.pagination += '<span onclick="lx.ir.changePage(1, true);" title="Next Page">></span>' +
                '<span onclick="lx.ir.changePage(' + lPages + ');" title="Last Page">>></span>';
        self.pagination = '<div class="pagination lxIrPagination">Page:&nbsp;&nbsp;' + self.pagination + ' | Total Records:' + self.data.totalCnt + '</div>';
    },
    refreshRow: function (pIRcode, pRowId, pData) {
        self = lx.ir;
        // search for row
        for (var i = 0; i < self.data.row.length; i++) {
            var row = self.data.row[i];
            if (row.id == pRowId) {
                // overwrite with new data
                for (var key in pData) {
                    if (pData.hasOwnProperty(key)) {
                        row[key] = pData[key];
                    }
                }
                var rowHtml = self.renderRow(row, self.data.columns);
                // replace row HTML
                $('#IR-' + self.data.genData.irCode + ' [rowid=' + row.id + ']').replaceWith(rowHtml);
                return;
            }
        }

    },
    changePage: function (pageNr, relative) {
        self = this;
        self.data.genData.page = (relative ? (self.data.genData.page + pageNr) : pageNr);
        self.getData('PAGE');
    },
    filter: function (pThis) {
        self = this;
        $IR = $(pThis).closest(".lxIr");
        self.data.genData.searchTerm = $IR.find(".lxIrSearch").val();
        self.data.genData.dateFrom = $IR.find(".lxIrDateFrom").val();
        self.data.genData.dateTo = $IR.find(".lxIrDateTo").val();
        for (var x = 0; x < self.data.filterItems.length; x++) {
            var filter = self.data.filterItems[x];
            if (filter.paramNo) self.data.genData.params[filter.paramNo - 1] = $v(filter.id);
        }
        self.data.genData.page = 1;
        $(pThis).closest(".lxIr").find(".lxIrSearchBtn").removeClass("red");
        self.getData('FILTER');
    },
    setSearchCol: function (pThis, pCol) {
        var $srch = $(pThis).closest(".lxIrSearchContainer");
        this.data.genData.searchCol = pCol;
        $srch.find(".lxIrSearch").attr("placeholder", $(pThis).text()).focus();
        $(pThis).parent().hide();
    },
    setParam: function (pThis, pPno, pVal) {
        self = this;
        self.data.genData.params[pPno - 1] = pVal;
        self.filter($(pThis).find('.lxIr .lxIrSearchContainer'));
    }
};

// Previous - checkboxChg 
lx.ir.checkboxChg = function(pThis, pType, pVal) {
    lx.load.add();
    apex.server.process("CHECKBOX_CHG", {
        x01: pThis.value,
        x02: pThis.checked ? 'Y' : 'N',
        x03: pType,
        x04: pVal
    }, {
        dataType: "html",
        success: function (d) {
            lx.load.remove();
            if (pType == 'HRD' || pType == 'EVT') {
                if (pVal == '0'){
                    if ($(".chkAll:checked").length == $(".chkAll").length) $(".chkDoc").prop("checked", true).trigger("change");
                    else $(".chkDoc").prop("checked", false).trigger("change");
                } else if (pVal != '0'){
                    if ($(".chkDoc:checked").length != $(".chkDoc").length) {
                        if (($(".chkAll:checked").length == $(".chkAll").length)) {
                            $(".chkAll").prop("checked", false).trigger("change");
                        }
                    }
                }
                // refresh IR
                if (pType == 'HRD') {
					apex.region("HR-calendar").refresh();
                } else if (pType == 'EVT') {
					apex.region("profile_cal").refresh();
                }
            } else if (pType == 'CON'){
                $("input[value="+ pThis.value +"]").prop("checked", pThis.checked);
            }
        }
    });
};

// TODO cleanup after we ditch the old app
var checkboxChg = lx.ir.checkboxChg;